import React, { Component } from 'react';
import {
  Divider,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import TimesStamp from '../../../../TimeStamp';
import styles from './MessageDivider.less';

class TimeDivider extends Component {
  render() {
    const { time } = this.props;
    return (
      <div>
        <div className={styles.timeDivider}>
          <TimesStamp time={time} />
        </div>
      </div>
    );
  }
}

TimeDivider.propTypes = {
  time: PropTypes.number,
};
TimeDivider.defaultProps = {
  time: '',
};

export default TimeDivider;
